<template>
    <div>
        <el-tabs v-model="activeTab" >
            <el-tab-pane label="列表" name="list">
                <el-form :inline="true" label-width="68px" class="searchListInput">
                    <el-form-item class="mb8">
                        <el-button type="primary" icon="el-icon-finished" size="mini" @click="save"
                                   class="elButtonSearch">保存
                        </el-button>
                    </el-form-item>

                </el-form>

                <el-form
                        ref="form"
                        :model="form"
                        :rules="rules"
                        label-width="100px"
                >
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="系统名称" prop="systemTitle">
                                <el-input
                                        v-model="form.systemTitle"
                                        placeholder="系统名称"
                                        size="small"
                                        style="width: 150px"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="公司名称" prop="systemCompany">
                                <el-input
                                        v-model="form.systemCompany"
                                        placeholder="公司名称"
                                        size="small"
                                        style="width: 150px"
                                />
                            </el-form-item>
                        </el-col>

                    </el-row>


                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {selectList, add, detail} from '../../api/system/systemCustomConfig'

    export default {
        // name: "Spring",
        data() {
            return {
                activeTab: 'list',
                // 表单参数
                form: {},
                // 表单校验
                rules: {
                    systemTitle: [
                        {required: true, message: "系统名称不能为空", trigger: "blur"}
                    ],

                    systemCompany: [
                        {required: true, message: "公司名称不能为空", trigger: "blur"}
                    ],


                }
            }
        },

        created() {
            this.handleQuery();
        },

        methods: {
            async handleQuery() {
                const response = await selectList().then();
                this.form = response.data;
                if (this.form == null) {
                    this.form = {};
                }
            },
            async save() {
                const response = await add(this.form).then();
                const id = response.data;
                this.msgSuccess("保存成功")
                await this.viewDetail(id);
            },

            async viewDetail(id) {
                const response = await detail({id: id}).then();
                this.form = response.data;
            },

        },
    }
</script>

<style scoped lang="scss">
.el-tabs {
  padding: 0 10px;
  height: 100%;
  .el-tab-pane {
    height: calc(100% - 100px);
  }
}
    .elButtonSearch {
        background: var(--buttonColor);
        border: 1px solid var(--buttonColor);

        &:hover {
            background: var(--buttonActiveColor);
            border: 1px solid var(--buttonActiveColor);
        }
    }

    .searchListInput {
        .el-input__inner {
            &::placeholder {
                color: #838689;
            }
        }

        .el-date-editor .el-range-input {
            &::placeholder {
                color: #838689
            }
        }

        .el-form-item {
            margin-bottom: 0.25rem;
        }
    }

    .rg_bottom {
        border-bottom: 1px solid #D8DCE4;
        border-left: 1px solid #D8DCE4;
        border-right: 1px solid #D8DCE4;
        height: 0.45rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0.15rem;
    }
</style>
